<style lang="scss" scoped>
svg {
    @apply md:w-40 md:h-40 w-24 h-24;
}

.jobs-link {
    svg {
        @apply md:w-20 md:h-20 w-12 h-12;
    }
}
</style>

<template>
    <div class="sector-grid md:-mx-12 flex flex-wrap -mx-8 -mb-24" v-if="!loading && sectors.length">
        <div class="xl:w-1/4 md:w-1/3 md:px-12 w-1/2 px-8 mb-24" v-for="sector in sectors.slice(0, 7)" :key="sector.id">
            <a :href="`/jobs?sector=${sector.slug}`" class="pt-full bg-light group hover:bg-green relative block transition-colors rounded-sm">
                <div class="lg:p-40 text-green group-hover:text-white absolute inset-0 flex flex-col justify-between w-full h-full p-16 transition-colors">
                    <svg fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <use :xlink:href="`/svg/feather-sprite.svg#${sector.icon ? sector.icon : 'user'}`" />
                    </svg>
                    <div>
                        <p class="text-dark group-hover:text-white lg:text-h4 md:mb-12 mb-8 font-bold transition-colors">
                            <v-clamp autoresize :max-lines="2" class="function" v-html="sector.name"></v-clamp>
                        </p>
                        <p class="text-gray group-hover:text-white md:text-tiny text-miniscule md:whitespace-nowrap font-bold uppercase transition-colors">{{ sector.total ? sector.total : '0' }} openstaande vacature{{ sector.total == 1 ? "" : "s" }}</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="xl:w-1/4 md:w-1/3 md:px-12 w-1/2 px-8 mb-24">
            <a class="pt-full bg-green group jobs-link relative block rounded-sm" href="/jobs">
                <div class="lg:p-40 absolute inset-0 flex flex-col justify-between w-full h-full p-16 text-white">
                    <p class="lg:text-h4 font-dm mb-12 font-bold leading-normal">Ontdek {{ vacancyCount < 10 ? `de ${vacancyCount}` : `${vacancyCountRounded}+` }} gevraagde profielen</p>
                    <div class="flex items-center justify-between">
                        <span class="md:text-h5 text-tiny font-dm whitespace-nowrap font-bold">Bekijk meer</span>
                        <svg class="group-hover:translate-x-8 transition-transform transform" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <use xlink:href="/svg/feather-sprite.svg#arrow-right" />
                        </svg>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import VClamp from "vue-clamp";

export default {
    components: {
        VClamp
    },

    data: () => ({
        loading: false,
        sectors: []
    }),

    mounted() {
        this.getSectors();
    },

    methods: {
        getSectors() {
            this.loading = true;
            axios
                .get("/api/sectors?used=true&counts=true")
                .then(response => this.handleFetch(response.data))
                .catch(error => this.handleError(error))
                .finally(() => {
                    this.loading = false;
                });
        },

        handleFetch(data) {
            this.sectors = data;
        },

        handleError(e) {
            console.error(e);
        }
    },

    computed: {
        vacancyCount() {
            let total = 0;

            this.sectors.forEach(s => {
                total = total + s.count;
            });

            return total;
        },

        vacancyCountRounded() {
            return Math.floor(this.vacancyCount / 10) * 10;
        }
    }
};
</script>
